<template>
 <div class="coocaa-plugin-loader" :class="{ 'plugin-error': isError }">
  <slot name="tips"
    v-if="tipMsg"
    :tips="{
      content: tipMsg
    }"
  >
    <div class="plugin-tip" >{{ tipMsg }}</div>
  </slot>
  <micro-app
    v-if="!isError && pluginUrl"
    :name="appName"
    :url='pluginUrl'
    :data="appData"
    @datachange="handleDataChange"
    @mounted="handleMounted"
    @error="handleError">
  </micro-app>
 </div>
</template>
<script>
import microApp from '@micro-zoe/micro-app'
import { getPluginInfo, genPluginService } from './service/plugin'
import { getPluginOptions } from '../utils/pluginOptions'
import { API_PREFIX_MAP } from '../utils/constant'
import { genRandom } from '../utils/common'
export default {
  name: 'PluginLoader',
  props: {
    // 插件唯一ID
    name: {
      type: String
      // required: true,
      // default: `${genRandom()}_?`
    },
    // 插件包名称
    pluginPackageName: {
      type: String,
      required: true
    },
    pluginFileName: {
      type: String,
      required: true
    },
    // 插件属性
    pluginProps: {
      type: Object,
      default () {
        return {}
      }
    },
    // 插件事件
    pluginEvents: {
      type: Object,
      default () {
        return {}
      }
    },
    // 插件服务
    pluginService: {
      type: Object,
      default () {
        return { edit: {}, detail: {}, delete: {} }
      }
    },
    tenantId: {
      type: String,
      default: '634d1c89d56d47eda5684480ec888e23' // 默认使用酷开的租户ID
    },
    dataId: { type: [String, Number] },
    dataIdKey: { type: String, default: 'id' }
  },
  data () {
    return {
      pluginComponentInstance: undefined, // 外部只能在 mounted 阶段才能获取到该变量
      isError: false,
      tipMsg: '',
      plginServices: undefined,
      plginData: undefined,
      pluginUrl: '',
      pluginOptions: undefined // { loaderOptions, pluginInfo, apiPrefixMap }
    }
  },
  computed: {
    appName () {
      return `${this.pluginPackageName}_${this.pluginFileName}_${this.name || genRandom()}`
    },
    appData () {
      return {
        props: this.pluginProps,
        event: this.pluginEvents,
        data: this.plginData,
        options: this.pluginOptions // { loaderOptions, pluginInfo, apiPrefixMap }
      }
    }
  },
  watch: {
    pluginProps (x) {
      console.log('pluginProps watch', x)
    },
    appData (v) {
      // 发送数据给子应用
      microApp.setData(this.appName, v)
    },
    isError (isError) {
      if (isError) {
        this.$emit('error', this.tipMsg)
      }
    }
  },

  methods: {
    handleDataChange (e) {
      const data = e.detail.data || {}
      const { componentInstance } = data
      this.pluginComponentInstance = componentInstance
    },
    handleMounted () {
      this.tipMsg = ''
      this.$emit('mounted')
    },
    handleError (e) {
      this.isError = true
      this.tipMsg = '渲染失败，请检查！'
      console.error('插件渲染失败，', e)
    },
    triggerAppEvent (event, ...params) {
      if (this.pluginComponentInstance) {
        return this.pluginComponentInstance[event](...params)
      }
    },
    // 更新插件数据
    saveOrUpdate (params) {
      return this.plginServices.saveOrUpdate(this.dataId, params).catch((err) => {
        console.error('更新插件数据失败：', err)
      })
    },
    // 获取插件数据
    async getPluginData (params) {
      if (!this.plginServices) {
        await this.initPluginServices()
      }
      if (this.plginServices) {
        this.plginServices.getPluginData(this.dataId, params).then((data) => {
          this.plginData = data.data
        })
      }
    },
    async initPluginServices () {
      try {
        const { pluginService, pluginInfo } = await getPluginInfo(this.pluginPackageName, this.pluginService, this.pluginOptions)
        let pluginOriginalName = pluginInfo.pluginName
        if (pluginOriginalName) {
          const { envProxy, apiPrefix, envMode, fixPluginName } = this.pluginOptions.loaderOptions
          const _apiPrefix = envProxy || `${window.location.origin}${apiPrefix}` // 插件代理
          pluginInfo.pluginOriginalName = pluginOriginalName
          const pluginPrefix = envMode === 'pro' ? '' : envMode
          if (pluginPrefix) {
            pluginInfo.pluginName = `${envMode}-${pluginOriginalName}`
          }
          // 修复插件名称
          if (typeof fixPluginName === 'function') {
            pluginInfo.pluginName = fixPluginName(pluginInfo)
          }
          // 保存插件信息
          this.pluginOptions = {
            ...this.pluginOptions,
            pluginInfo, // 插件信息
            tenantId: this.tenantId
          }
          this.plginServices = genPluginService({ pluginConfig: pluginService, dataIdKey: this.dataIdKey, pluginOptions: this.pluginOptions })
          this.pluginUrl = `${_apiPrefix}/cc-plugin/static-plugin/${pluginInfo.pluginName}/${this.pluginFileName}.html`
          // this.pluginUrl = `http://localhost:8282/${this.pluginFileName}.html`
        } else {
          this.isError = true
          this.tipMsg = '未启用，请检查！'
        }
      } catch (error) {
        console.log(error)
        this.isError = true
        this.tipMsg = '未启用，请检查！'
      }
    }
  },
  async created () {
    this.pluginOptions = {
      apiPrefixMap: API_PREFIX_MAP, // 插件接口代理
      loaderOptions: getPluginOptions(), // 加载器初始化时配置信息
      tenantId: this.tenantId
    }
    this.initPluginServices()
  }
}
</script>
<style scoped>
.coocaa-plugin-loader .plugin-tip {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 10px;
  color: #909399;
}
.coocaa-plugin-loader.plugin-error .plugin-tip {
  color: #F56C6C;
  border-color: #F56C6C;
}
</style>
